import React from 'react'
import { Button } from 'react-bootstrap'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null

  return (
    <div className="d-flex justify-content-center align-items-center mt-4">
      <Button
        variant="outline-secondary"
        size="sm"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="me-3"
      >
        ← Previous
      </Button>

      <span className="mx-3">
        Page {currentPage} of {totalPages}
      </span>

      <Button
        variant="outline-secondary"
        size="sm"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="ms-3"
      >
        Next →
      </Button>
    </div>
  )
}

export default Pagination
